import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const cityServices = createApi({
  reducerPath: "city",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL,
  }),
  endpoints: (builder) => ({
    getCityList: builder.query({
      query: () => ({
        url: "/api/citylist.php",
        method: "GET",
      }),
      providesTags: ["cityOperation"],
    }),
    getPOIList: builder.query({
      query: () => ({
        url: "/api/city_poi_list.php",
        method: "GET",
      }),
      providesTags: ["cityOperation"],
    }),
  }),
  tagTypes: ["cityOperation"],
});

export const { useGetCityListQuery, useGetPOIListQuery } = cityServices;

export default cityServices;
